import React, {Component} from "react";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";
import CodeBlock from "../../../common/CodeBlock";
import SiteService from "../../../service/SiteService";

class Samples extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Samples</h1>
                                <p>Welcome to the {SiteService.getSiteName()} samples cookbook.</p>
                                <p>Here you'll find recipes to accomplish particular tasks. Feel free to combine and adapt these to your needs.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h3>Simple Jenkins job</h3>
                                <CodeBlock code={`# Simple action example for Jenkins.
---
version: '1'

actions:
  deploy-services:
    driver: jenkins
    jobId: "example"
    template: deploy services {version} to {environment}
`}/>

                                <h3>Simple Rundeck job</h3>
                                <p>Here, the 'jobId' is the UUID of the Rundeck job.</p>
                                <CodeBlock code={`# Simple action example for Rundeck.
---
version: '1'

actions:
  deploy-services:
    jobId: 9374f1c8-7b3f-4145-8556-6b55551fb60f
    template: deploy services {version} to {environment}
`}/>

                                <h3>Multiple actions with tags</h3>
                                <CodeBlock code={`# Multiple actions withs tags.
---
version: '1'

actions:
  deploy-services:
    driver: jenkins
    jobId: "Deploy-Services"
    template: deploy services {version} to {environment}
    tags:
      - services

  restart-services:
    driver: jenkins
    jobId: "Restart-Services"
    template: restart services in {environment}
    tags:
      - services
`}/>

                                <h3>Action with default options</h3>
                                <CodeBlock code={`# Action with default options.
---
version: '1'

actions:
  deploy-services:
    driver: jenkins
    jobId: "Deploy-Services"
    template: deploy services {version} to {environment}
    options:
      myOption:
        value: someValue
      myOtherOption:
        value: someOtherValue
`}/>

                                <h3>Action with option transformers</h3>
                                <CodeBlock code={`# Action with option transformers.
---
version: '1'

actions:
  deploy-services:
    driver: jenkins
    jobId: "Deploy-Services"
    template: deploy services {version} to {environment}
    options:
      version:
        transformers:
          - LOWERCASE
      environment:
        transformers:
          - UPPERCASE
`}/>

                                <h3>Action with lockable option</h3>
                                <CodeBlock code={`# Action with lockable option.
---
version: '1'

actions:
  deploy-services:
    driver: jenkins
    jobId: "Deploy-Services"
    template: deploy services {version} to {environment}
    options:
      environment:
        lockable: true
        transformers:
          - LOWERCASE
`}/>

                                <h3>Actions protected by custom authorisation rules</h3>
                                <CodeBlock code={`# Actions protected by custom authz rules.
---
version: '1'

actions:
  deploy-services:
    driver: jenkins
    jobId: "Deploy-Services"
    template: deploy services {version} to {environment}
    tags:
      - services

  restart-services:
    driver: jenkins
    jobId: "Restart-Services"
    template: restart services in {environment}
    tags:
      - services

security:
  roles:
    # a role that can only trigger jobs
    deployer:
      permissions:
        - trigger
      tags:
        - all

  users:
    # alice uses the built-in 'admin' role
    alice:
      roles:
        - admin

    # all users can trigger jobs
    "*":
      roles:
        - deployer
`}/>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default Samples;



// WEBPACK FOOTER //
// ./src/modules/views/docs/bot/Samples.js